import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BlogCard from "./BlogCard";
import hybridBlogService from "../../services/hybridBlogService";
import ReactGA from "react-ga4";
import { useTranslation } from "../../hooks/useTranslation";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { getLocalizedPath } = useTranslation();

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        setLoading(true);
        setError(null);
        const fetchedBlogs = await hybridBlogService.fetchBlogList();
        setBlogs(fetchedBlogs.slice(0, 3)); // Show only first 3 for homepage
      } catch (err) {
        console.error('Error loading homepage blogs:', err);
        setError('Failed to load blogs');
        // Fallback to empty array
        setBlogs([]);
      } finally {
        setLoading(false);
      }
    };

    loadBlogs();
  }, []);

  const handleViewAllBlogs = () => {
    ReactGA.event({
      category: 'CTA',
      action: 'View All Blogs',
      label: 'homepage'
    });
    navigate(getLocalizedPath('/blog'));
  };

  return (
    <div className="blog-section" style={{ position: 'relative' }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(/assets/images/blog/blog-background.webp)',
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto',
        opacity: 0.2,
        pointerEvents: 'none'
      }}></div>
      <div className="blog-content-wrapper" style={{ position: 'relative', zIndex: 1 }}>
        <h2 className="blog-title">Get Inspired for Your Road Trip!</h2>
        <div className="blog-cards-container">
          {loading ? (
            <div>Loading blogs...</div>
          ) : error ? (
            <div style={{ color: 'red' }}>Error: {error}</div>
          ) : blogs.length > 0 ? (
            blogs.map((blog, index) => (
              <BlogCard key={blog.slug || index} blog={{
                heading: blog.title,
                description: blog.excerpt,
                image: blog.image,
                readTime: blog.readTime,
                date: blog.date,
                slug: blog.slug
              }} />
            ))
          ) : (
            <div>No blogs available</div>
          )}
        </div>
        <div className="view-all-blogs-button" onClick={handleViewAllBlogs} style={{ cursor: 'pointer' }}>
          <div className="button-state-layer">View All Blogs</div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
